const TimeToValue = () => {
  return (
    <section className="bg-brand-blue py-8 sm:py-6">
      <div className="mx-auto max-w-5xl px-6 lg:px-8 flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
        <div className="flex items-baseline gap-3 md:flex-shrink-0">
          <span className="text-xs font-semibold uppercase tracking-widest text-white/80">
            Live in
          </span>
          <span className="text-3xl font-light text-white leading-none tabular-nums">
            4<span className="text-white/60"> to </span>8 weeks
          </span>
        </div>
        <p className="text-sm text-white/90 leading-relaxed m-0">
          From a signed agreement. Data integration with your council hazard layers is the variable.
        </p>
      </div>
    </section>
  )
}

export default TimeToValue
